
import {mapGetters, mapMutations, mapState} from 'vuex';
import env from '@/.env.json';
import OrderListItemWrapper from '~/components/catalog/orderList/Item/Wrapper';
import OrderListItem from '~/components/catalog/orderList/Item';
import {receiveMethods} from '~/plugins/enums/checkout';
import {dateFormat} from '~/plugins/formatting';

export default {
  name: 'OrderListDeliveriesItem',
  components: { OrderListItemWrapper, OrderListItem },
  props: {
    item: {
      type: Object,
      required: true,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infoPickupDisabled: env.DELIVERY_PICKUP_DISABLED || false,
    }
  },
  computed: {
    ...mapState('geolocation', [ 'selectedCity' ]),
    ...mapGetters({
      getSelectedCity: 'geolocation/getSelectedCity',
      getSelectedCityType: 'geolocation/getSelectedCityType',
    }),
    deliveryData() {
      return {
        [receiveMethods.DELIVERY]: {
          name: 'Доставка курьером —',
          placeName: 'со склада',
        },
        [receiveMethods.PICKUP]: {
          name: 'Самовывоз —',
          placeName: 'из ПВЗ',
        },
      }
    },
    currentDelivery() {
      return this.deliveryData[this.item.delivery_method] || {
        name: 'Доставка',
        placeName: '',
      }
    },
  },
  methods: {
    ...mapMutations('geolocation', {
      setVisibleLocationModal: 'SET_VISIBLE_LOCATION_MODAL',
    }),
    dateFormat,
    openLocationModal() {
      this.setVisibleLocationModal(true);
    },
  },
}
